


















import { Component, Prop, Vue, Watch, Ref } from 'vue-property-decorator'

@Component
export default class LegalButtons extends Vue {}
